import { createSlice } from "@reduxjs/toolkit";
import { getStakeholderSatisfactions } from "../actions/stakeholderSatisfaction.actions";
import { StakeholderSatisfactionApi } from "../../interfaces/StakeholderSatisfaction.types";

const initialState = {
  stakeholderSatisfactions: [] as StakeholderSatisfactionApi[],
  loading: false,
  error: null as unknown | null,
};
export const stakeholderSatisfactionSlice = createSlice({
  name: "stakeholderSatisfaction",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStakeholderSatisfactions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStakeholderSatisfactions.fulfilled, (state, action) => {
        state.stakeholderSatisfactions = action.payload ?? [];
        state.loading = false;
      })
      .addCase(getStakeholderSatisfactions.rejected, (state, action) => {
        state.stakeholderSatisfactions = [];
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default stakeholderSatisfactionSlice.reducer;
